<template>
    <div id="app">
        <div class="headerFix">
            <app-header v-if="header_show"></app-header>
        </div>
        <div class="emptyHeader"></div>
        <keep-alive> 
            <router-view v-if="$route.meta.keepAlive" v-on:header="header"></router-view> 
        </keep-alive> 
        <router-view v-if="!$route.meta.keepAlive" v-on:header="header"></router-view>
    </div>
</template>

<script>
import Header from '@/components/common/Header';
export default { 
    name: 'App',
    data () {
        return {
            header_show: true,
        }
    },
    components: {
        'app-header': Header,
    },
    methods: {
        header: function (bool) {
            this.header_show = bool;
        }
    }
}
</script>

<style>
@import './styles/quill';
#app {
    font-family: 'bodyFont','Helvetica Neue',Helvetica,'Roboto',Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #003448;
}
.headerFix{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
}
.emptyHeader{
    width: 100%;
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue